import React, { useState } from "react";
import { Button, Container, Grid, Paper, TextField } from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import api from "../../api/axios";
import { toast } from "react-toastify";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export default function ResendConfirmation() {
  const [captchaValue, setCaptchaValue] = useState(null);

  const onSubmit = async (data, props) => {
    if (!captchaValue) {
      toast.error("Por favor, verifique el captcha");
      return;
    }

    try {
      const response = await api.post("/api/v1/confirmation", {
        email: data.email,
        captcha: captchaValue,
      });
      toast.success(response.data.message);
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
      } else {
        toast.error(err.response.data.error);
      }
    }
  };
  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string("Debe ser una cadena de caracteres")
      .required("Ingrese su correo")
      .email("Debe ser un correo válido"),
  });
  return (
    <Container maxWidth="sm">
      <h1 align="center">Enviar confirmación</h1>
      <Grid
        container
        spacing={2}
        direction="column"
        justifyContent="center"
        style={{ minHeigt: "100vh" }}
      >
        <Paper elevation={2} sx={{ padding: 5 }}>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            {(props) => (
              <Form>
                <Grid container direction="column" spacing={2}>
                  <Grid item>
                    <Field
                      as={TextField}
                      name="email"
                      htmlFor="email"
                      type="text"
                      fullWidth
                      label="Ingrese su correo"
                      placeholder="Correo electrónico"
                      variant="outlined"
                      autoFocus
                      error={!!props?.errors?.email && props?.touched?.email}
                      helperText={<ErrorMessage name="email" />}
                    />
                  </Grid>
                  <Grid item>
                    <ReCAPTCHA
                      sitekey={SITE_KEY}
                      onChange={(value) => setCaptchaValue(value)}
                    />
                  </Grid>

                  <Grid item>
                    <Button
                      variant="contained"
                      fullWidth
                      type="submit"
                      disabled={props.isSubmitting}
                    >
                      Enviar
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Paper>
      </Grid>
    </Container>
  );
}
